import { render } from "./ChannelIntro.vue?vue&type=template&id=59569a93"
import script from "./ChannelIntro.vue?vue&type=script&lang=js"
export * from "./ChannelIntro.vue?vue&type=script&lang=js"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__